enum ACTION {
  BidEvent = 'sse/BidEvent',
  HeartbeatEvent = 'sse/HeartbeatEvent',
  AuctionChangeEvent = 'sse/AuctionChangeEvent',
  TradeChangeEvent = 'sse/TradeChangeEvent',
  TradeStateChangeAllEvent = 'sse/TradeStateChangeAllEvent',
  NegotiationEvent = 'sse/NegotiationEvent'
}

export enum EVENTS {
  AUCTION_CHANGE = 'AuctionChangeEvent',
  BID_EVENT = 'BidEvent',
  HEART_BEAT = 'HeartbeatEvent',
  NEGOTIATION_EVENT = 'NegotiationEvent',
  STATE_CHANGE = 'TradeStateChangeAllEvent',
  TRADE_CHANGE = 'TradeChangeEvent'
}

export type SSEActions =
  | AuctionChangeEventAction
  | BidEventAction
  | HeartbeatEventAction
  | NegotiationEvent
  | TradeChangeEventAction
  | TradeStateChangeAllEvent;

/* Action Types */
export type BidEventAction = {
  type: ACTION.BidEvent;
  payload: object;
};

/* Action Types */
export type HeartbeatEventAction = {
  type: ACTION.HeartbeatEvent;
  payload: object;
};

export type AuctionChangeEventAction = {
  type: ACTION.AuctionChangeEvent;
  payload: object;
};

export type TradeChangeEventAction = {
  type: ACTION.TradeChangeEvent;
  payload: object;
};

export type TradeStateChangeAllEvent = {
  type: ACTION.TradeStateChangeAllEvent;
  payload: object;
};

export type NegotiationEvent = {
  type: ACTION.NegotiationEvent;
  payload: object;
};

export default ACTION;
